// extracted by mini-css-extract-plugin
export default {"custom-file":"ModalSubDomain_custom-file__Tzqgk","custom-button":"ModalSubDomain_custom-button__gAZRU"};